<template>
    <div>
        <div v-if="!content_pending && !content_error">
            <h1>{{content.title}}</h1>
            <div>
                <div v-html="content.html_content"></div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
const { $apiFetch } = useNuxtApp()
const { locale } = useI18n()
const route = useRoute()

definePageMeta({
    auth: 'guest',
    layout: 'about-layout',
})

const { data: content, pending: content_pending, error: content_error } = await useAsyncData('about-content', async () => {
    return await $apiFetch(`/${locale.value}/api/site/staticpages/about/${route.params.slug[0]}/`)
})

if(content_error.value) {
    throw createError({
        statusCode: 404,
        statusMessage: 'Page not found',
        fatal: true,
    })
}




useHead({
    title: content.value?.title,
})

</script>